import { SEARCH, SEARCH_QUERY, SEARCH_MORE_ALLOWED,
  SEARCH_LESS_ALLOWED, SEARCH_MORE, SEARCH_LESS } from '@store/types'
import axios from 'axios'

const state = {
  index: '',
  query: '',
  results: {},
  page: '',
  pages: ''
}

const getters = {
  [SEARCH]: ({ results }) => results,

  [SEARCH_QUERY]: ({ query }) => query,

  [SEARCH_MORE_ALLOWED]: (state) => {
    return state.page < state.pages - 1
  },

  [SEARCH_LESS_ALLOWED]: (state) => {
    return state.page - 1 >= 0
  }
}

const mutations = {
  [SEARCH_QUERY]: (state, query) => {
    state.query = query
  },

  [SEARCH]: (state, result) => {
    state.results = result
    state.page = result.page
    state.pages = result.pages
  }
}

const actions = {
  [SEARCH]: async ({ state, commit }, payload) => {
    if (payload.query !== undefined && payload.query !== state.query) {
      commit(SEARCH_QUERY, payload.query)
    }

    const send = {
      'index': payload.index || 'companies',
      'query': state.query,
      'page': payload.page || '0',
      'hitsPerPage': '5'
    }

    const { data: response } = await axios.post('/search', send)

    commit(SEARCH, {
      results: response.data.searchResult,
      page: payload.page || 0,
      pages: response.data.pages
    })
  },

  [SEARCH_MORE]: ({ dispatch, state }, index) => {
    dispatch(SEARCH, {
      index,
      page: state.page + 1
    })
  },

  [SEARCH_LESS]: ({ dispatch, state }, index) => {
    dispatch(SEARCH, {
      index,
      page: state.page - 1
    })
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/search.js